import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export const DELIVERY_DATE_VARIANT = {
  INLINE: 'inline',
  BADGE: 'badge',
} as const;

export type DeliveryDateVariant = typeof DELIVERY_DATE_VARIANT[keyof typeof DELIVERY_DATE_VARIANT];

@Component({
  selector: 'app-expected-delivery-date',
  imports: [CommonModule],
  templateUrl: './expected-delivery-date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpectedDeliveryDateComponent {
  expectedDeliveryDate = input.required<{ from?: Date; to?: Date }>();
  dayDifference = input<number>();
  variant = input<DeliveryDateVariant>(DELIVERY_DATE_VARIANT.INLINE);

  readonly VARIANT = DELIVERY_DATE_VARIANT;
}
